import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { css } from "styled-components";
import { createStyleComponent } from "@hzero-front-ui/core";
function getRichTextStyle() {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    /* \u8FD9\u4E2A\u6837\u5F0F\u7684\u5B9E\u73B0\u5728components/slider\u4E2D\u5B8C\u6210\uFF0C\u5982\u679C\u6709\u9644\u52A0\u6837\u5F0F\uFF0C\u53EF\u4EE5\u5199\u5728\u8FD9\u91CC  */\n  "])));
}
export default createStyleComponent("richtext", getRichTextStyle);